import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';
import {InvoicePage} from '../../model/pagination/billing/invoice-page.model';

@Injectable()
export class InvoicesResolver implements Resolve<Observable<InvoicePage>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<InvoicePage> {
    const pageIndex = route.queryParams['pageIndex'] ?? 0;
    const pageSize = route.queryParams['pageSize'] ?? 20;
    return this.facadeService.getPageInvoice(pageIndex, pageSize).pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
